// src/pages/Projects.jsx
import { useState } from 'react';
import ProjectCard from '../components/ProjectCard';
import { usePortfolioViewModel } from '../viewmodels/usePortfolioViewModel';

export default function Projects() {
  const [isExpanded, setIsExpanded] = useState(false);
  const {
    activeFilter,
    filteredProjects,
    filterTabs,
    handleFilterChange,
  } = usePortfolioViewModel();

  const INITIAL_DISPLAY = 6;
  const displayedProjects = isExpanded ? filteredProjects : filteredProjects.slice(0, INITIAL_DISPLAY);
  const hasMore = filteredProjects.length > INITIAL_DISPLAY;

  return (
    <section className="section" id="portfolio">
      {/* Hidden anchor for projects */}
      <span id="projects" className="block relative -top-24 invisible"></span>
      <div className="container text-center">
        <p className="section-subtitle">What I Did ?</p>
        <h6 className="section-title mb-6">Portfolio</h6>

        {/* Filter tabs styled as Meyawo buttons */}
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {filterTabs.map((tab) => (
            <button
              key={tab}
              onClick={() => handleFilterChange(tab)}
              className={`capitalize transition-all duration-200 ${
                activeFilter === tab
                  ? 'btn btn-primary btn-sm rounded'
                  : 'btn btn-outline-primary btn-sm rounded'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Project grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {displayedProjects.map((project) => (
            <ProjectCard
              key={project.id}
              project={project}
            />
          ))}
        </div>

        {/* See More button */}
        {hasMore && (
          <div className="flex justify-center mt-12">
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="btn btn-outline-primary btn-rounded shadow-sm"
            >
              {isExpanded ? 'Show Less' : 'See More Projects'}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
